import React, { useState, Fragment } from "react";
import {
  GET_ONE,
  GET_LIST,
  SimpleForm,
  Create,
  Toolbar,
  SaveButton,
  SelectInput,
} from "react-admin";
import { Card, Button, CardContent } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from "moment-timezone";
import {
  map,
  curry,
  range,
  filter,
  compose,
  isEmpty,
  prop,
  propEq,
  isNil,
} from "ramda";
import { TextInput } from "react-admin";
import LinearProgress from "@material-ui/core/LinearProgress";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import ReactExport from "react-export-excel";
import { required } from "ra-core";
// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
import ReactExport from "react-data-export";

import { API_ROOT } from "../api-config";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "50%",
  },
  flex: { display: "flex", flexDirection:'column' },
  emailsCard: {padding: '10px 20px', backgroundColor: 'rgb(254 151 0 / 12%)', borderRadius: '4px',
              boxShadow: 'rgb(255 152 0 / 2%) 0px 30px 60px -12px inset, rgb(253 229 193) 0px 18px 36px -18px inset', 
              display: "flex", flexDirection: "row", margin: "20px", width: '50%', flexWrap: 'wrap'}
};

let dataSetAll = [];
let dataSetRentals = [];
let dataSetOld = [];
let yearsArray = [];

let locationJson = null;

class reportEmail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      locationsArray: null,
      locationSearch: null,
      yearsEnd: moment().startOf("year").format("YYYYMMDD"),
      optDateBegin: null,
      optDateEnd: null,
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment().startOf("month").format("YYYYMMDD"),
      emailsGroup: null,
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");

    const startDate = moment()
      // .startOf("year")
      .format("YYYYMMDD");

    const endDate = moment()
      // .startOf("year")
      // .add(2, "month")
      .format("YYYYMMDD");

    await this.fetchLocations(); 
    await this.updateState(startDate, endDate, null, null, null);
  }

  updateState = async (startDate, endDate, optDateBegin, optDateEnd) => {
    const numberOfMonths = moment(endDate).diff(moment(startDate), "months");

    this.setState({
      numberOfMonths,
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate)
        //   .startOf("month")
        .format("YYYYMMDD"),
      optDateBegin,
      optDateEnd,
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChangeOptE = (eventDate) => {
    this.setState({ optDateEnd: eventDate });
  };

  handleChangeOptB = (eventDate) => {
    this.setState({
      optDateBegin: eventDate,
    });
  };

  handleValueChangeSelect = (e, newValue) => {
    this.setState({ locationSearch: newValue });
  };

  handleDateTimeChange = (event, fieldName) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetRentals = [];
    dataSetAll = [];
    dataSetOld = [];
    if (
      this.state.optDateBegin !== null &&
      this.state.optDateEnd !== null &&
      this.state.optDateBegin !== "" &&
      this.state.optDateEnd !== ""
    ) {
      this.setState({ exportData: [], loading: true, showTables: true });
      this.getReports(
        this.state.optDateBegin,
        this.state.optDateEnd,
        this.state.locationSearch
      );
    }
  };

  async getReports(startDate, endDate, location) {

    const eventDateStart = moment(this.state.optDateBegin._d).format(
      "YYYY-MM-DD"
    );
    const eventDateEnd = moment(this.state.optDateEnd._d).format("YYYY-MM-DD");  
    const dataProvider = await dataProviderFactory("rest");
    const reportEmail = dataProvider(GET_LIST, "reports/reportEmails", {
      filter: {
        dateStart: eventDateStart,
        dateEnd: eventDateEnd,
        location: location,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    reportEmail
      .then(async (result) => {
        this.state.loading = false;
        dataSetAll = result.data;

        // Obtenemos una lista de todos los años disponibles
        yearsArray = Array.from(
          new Set(dataSetRentals.map((item) => item.years))
        );

        const dataSet = [
          {
            columns: [
              {
                title: "Client Name ",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Email",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
            ],
            data: dataSetRentals.map((data) => [
              {
                value: data.client_name != null ? data.client_name : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.email != null ? data.email : "",
                style: { font: { sz: "12" } },
              },
            ]),
          },
        ];

        this.setState({ loading: false, DataSet: dataSet });

        return result.data;
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }

  async fetchLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 50,
      },
      sort: { field: "id", order: "DESC" },
    });

    const baseLocations = filter((location) => {
      return (
        isNil(location.base_location_id) &&
        !propEq("location_name", "Other", location)
      );
    }, locations.data);
    locationJson = baseLocations;
    this.setState({ locations: baseLocations });
  }

  async getReportsDownload(startDate, endDate) {
    let data = {
      startDate: startDate,
      endDate: endDate,
    };

    const response = await fetch(`${API_ROOT}/reports/download`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
      body: JSON.stringify(data),
    });

    let commits = await response.json(); // read response body and parse as JSON

    let a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
    a.download = `Metrics.xlsx`;
    a.click();
    a.remove();
  }

  render() {
    const {
      isLoading,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const emailsByClient = {};
    dataSetAll.forEach(item => {
      if (!emailsByClient[item.language]) {
        emailsByClient[item.language] = {email: ''}
      }
      if (emailsByClient[item.language].email == ''){
        emailsByClient[item.language].email = item.email;
      }else {
        emailsByClient[item.language].email += ';' + item.email;
      }
    });

    const PostCreateToolbar = (props) => (
      <Toolbar {...props} style={{ backgroundColor: "transparent" }}>
        <SaveButton
          label="Generate"
          type="submit"
          onClick={this.handleChange}
        />
      </Toolbar>
    );

    return (
      <Card>
        <h3 style={{ display: "flex", margin: "20px" }}>Email Reports </h3>
        <div style={{ display: "flex", flexDirection: "row", margin: "20px" }}>
          <div>
            <SimpleForm toolbar={false}>
              <CustomDatePicker
                type="years"
                onChange={(e) => this.handleChangeOptB(e)}
                selectedDate={
                  optDateBegin && optDateBegin !== "null"
                    ? moment(optDateBegin).format("YYYY-MM-DD")
                    : null
                }
                label="Date Begin"
              />
              <CustomDatePicker
                onChange={(e) => this.handleChangeOptE(e)}
                selectedDate={
                  optDateEnd && optDateEnd !== "null"
                    ? moment(optDateEnd).format("YYYY-MM-DD")
                    : null
                }
                label="Date End"
              />
              <SelectInput
                source="location"
                choices={this.state.locations}
                label="Location"
                optionText="location_short_name"
                optionValue="id"
                allowEmpty={false}
                onChange={this.handleValueChangeSelect}
              />
            </SimpleForm>
          </div>
        </div>
        <PostCreateToolbar />

        {this.state.showTables ? (
          <div style={styles.flex}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3} style={styles.centerAlignedCell}>
                    <h3> Emails </h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={styles.centerAlignedCell}>Language</TableCell>
                  <TableCell style={styles.centerAlignedCell}>Emails</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(emailsByClient).map((language) => (
                  <TableRow key={language}>
                    <TableCell style={styles.centerAlignedCell}>
                      {language}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                      <p style={{ overflowWrap: 'break-word', wordBreak: 'break-all' }}>
                        {emailsByClient[language].email} 
                      </p>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>          
          </div> 
         ) : null}
        <div style={{ marginBottom: "10px" }}></div>
      </Card>
    );
  }
}

export default reportEmail;



// WEBPACK FOOTER //
// ./src/components/reportEmail.js